import React from "react";
import ReactDOM from "react-dom";
import "@fontsource/roboto/400.css";

import "./index.css";
import App from "./App";
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
